import React, { useEffect, useState } from "react";
import { Row, Col, Spinner } from "reactstrap";
import { Btn } from "../../../../AbstractElements";
import { useGetOrgUnitsData } from "../../../Employee/hooks/useEmployee";
import {
  useAddOutletOrgData,
  useGetOutletAddressList,
  useGetOutletVisitFrequency,
  useUpdateOutletOrgData,
} from "../hooks/useCustomer";
import CustomInput from "../../../../Component/BasicComponents/CustomInput";
import RouteDropdown from "../../../../Component/BasicComponents/Dropdowns/RouteDropdown";
import { useCustomerTagListData } from "../../Customer Tags/hooks/useCustomerTag";
import { useBrandList } from "../../../ProductCatalogue/hooks/useProductCatalogue";
import PaginatedRouteDropdown from "../../../../Component/BasicComponents/Dropdowns/PaginatedDropdownWrapper";
import { getBrandData } from "../../../ProductCatalogue/hooks/ProductRepository";
interface Prop {
  mode: "add" | "edit" | "view";
  modalClose: () => void;
  OutletId: number;
  selectedRow?: any;
onSuccess?: (createdOrgDataId: number) => void;
}

const OrganizationCustomerRecordModal: React.FC<Prop> = ({
  mode,
  modalClose,
  OutletId,
  selectedRow,
  onSuccess
}) => {
  console.log("OutletId", OutletId);
  console.log("selectedRow", selectedRow);
  const [orgUnit, setOrgUnit] = useState();
  const [visitFeq, setVisitFeq] = useState();
  const [remark, setRemark] = useState();
  const [tag, setTag] = useState<any[]>([]);
  const [address, setAddress] = useState();
  const [focusBrand, setFocusBrand] = useState<any[]>([]);
  const [investedAmount, setInvestedAmount] = useState();
  const [potential, setPotential] = useState();
  const [customerFrq, setCustomerFrq] = useState();
  const [focusBrandSearch, setFocusBrandSearch] = useState("");

  const { data: getOrgList } = useGetOrgUnitsData({
    enable: true,
  });

  const { data: VisitFrequency,isLoading:visitfreq } = useGetOutletVisitFrequency({
    enabled: true,
  });

  const { data: OutletAddress } = useGetOutletAddressList({
    enabled: true,
    outletId: OutletId,
  });

  const { data: tagList } = useCustomerTagListData({
    enable: true,
    params: {
      fetch: "all",
    },
  });

  const { data: getBrands } = useBrandList({
    enable: !!orgUnit,
    params: {
      Orgunitid: orgUnit,
      search: focusBrandSearch,
    },
  });

  const {mutate:AddOutletOrgData}=useAddOutletOrgData()
  const {mutate:UpdateOutletOrgData}=useUpdateOutletOrgData()

  const Formatted_Brands = Object.values(getBrands?.data?.data || {}).map(
    (key: any) => ({
      id: key.BrandId,
      label: key.BrandName,
    })
  );
  // console.log("formattedBrandf ", Formatted_Brands);
  // console.log("getbranslist", getBrands?.data);

  const Formatted_Tags = Object.values(tagList?.data?.data?.OutletTags || {}).map((key: any) => ({
    id: key,
    label: key,
  }))||[];

  const Formatted_visitFeq = (VisitFrequency?.data || []).map(
    (key: any, index: any) => ({
      id: index,
      label: key,
    })
  );

  // console.log("visitfreq", VisitFrequency?.data);
  // console.log("Formatted_visitFeq", Formatted_visitFeq);

  const Formatted_Address = (OutletAddress?.data?.OutletAddresses||[])?.map((key: any) => ({
      id: key.OutletAddressId,
      label: `${key.AddressName || ""} | ${key.OutletAddress || ""}`,
    })) || [];

useEffect(() => {
  if ((mode === "edit" || mode === "view") && selectedRow) {
    setOrgUnit(selectedRow?.OrgUnitId || null);
    setAddress(selectedRow?.DefaultAddress || null);

    // Set tags from comma-separated string to array of { id, label }
    const tagArray = selectedRow?.Tags?.split(",").map((tag: string) => {
      const trimmed = tag.trim();
      return  trimmed;
    }) || [];
    setTag(tagArray||[]);

    // Set visit frequency using label match
    // const matchedVisitFreq = Formatted_visitFeq.find(
    //   (item:any) => item.id === selectedRow?.VisitFq
    // );
    setVisitFeq(selectedRow?.VisitFq || null);

    setRemark(selectedRow.Remark||""); // If `comments` is present, use selectedRow?.comments

    setPotential(selectedRow?.OrgPotential || "");
    setCustomerFrq(selectedRow.customerFq||""); // If provided
    setInvestedAmount(selectedRow?.InvestedAmount || "");

    // Handle brand focus (comma-separated string -> array of { label, id })
    if (selectedRow?.BrandFocus) {
      const brandsArray = selectedRow.BrandFocus.split(",").map((brand: string) => ({
        label: brand.trim(),
        id: brand.trim(), // adjust if ID is known
      }));
      setFocusBrand(brandsArray);
    } else {
      setFocusBrand([]);
    }
  }
}, [mode, selectedRow]);

const formattedOrgUnit=getOrgList?.data?.slice(1)
console.log('formattedorgdata',formattedOrgUnit)


const handleSubmit = (e:React.FormEvent) => {
  e.preventDefault();
 const payload:any = {
    outletId: OutletId,
    orgUnitId: orgUnit,
    defaultAddress: address,
    tags: Array.isArray(tag) ? tag.map((t: any) => t.label || t) : [],
    visitFq: visitFeq || "",
    comments: remark || "",
    orgPotential: potential || "",
    brandFocus: focusBrand?.map((b: any) => b.label).join(", ") || "",
    customerFq: customerFrq || "",
    investedAmount: investedAmount || "",
  };

  console.log("Payload to submit:", payload);

if (mode === "add") {
  AddOutletOrgData(payload, {
    onSuccess: (res) => {
      const createdOrgDataId =
        res?.data?.OutletOrgId || res?.data?.OutletOrgId; // Based on API response

      if (onSuccess) {
        onSuccess(createdOrgDataId); // Pass the ID to parent
      } else {
        modalClose();
      }
    },
    onError: (err) => {
      console.error("Failed to add organization:", err);
    }
  });
} else if (mode === "edit") {
  payload.outletOrgDataId = selectedRow.OutletOrgId;
  UpdateOutletOrgData(payload, {
    onSuccess: (res) => {
      const updatedOrgDataId =
        selectedRow?.OutletOrgId || res?.data?.OutletOrgDataId; // Pick existing ID if editing
      if (onSuccess) {
        onSuccess(updatedOrgDataId); // Pass existing ID so parent logic stays consistent
      } else {
        modalClose();
      }
    },
    onError: (err) => {
      console.error("Failed to update organization:", err);
    }
  });
}


};

  return (
    <>
      {visitfreq ? (
        <div
          className="d-flex justify-content-center align-items-center"
          style={{ height: "60vh" }}
        >
          <Spinner color="primary" style={{ width: "3rem", height: "3rem" }} />
          {/* <span className="ms-3">Loading SGPI Brands...</span> */}
        </div>
      ) :(
    <div className="mt-3">
      <div className="row mb-0 col-sm-12">
        <div className="col-sm-6">
          <RouteDropdown
            DropdownHeading="Org Unit"
            placeholder="Select Org Unit"
            options={formattedOrgUnit || ["Org Unit A", "Org Unit B"]}
            onChange={(val: any) => setOrgUnit(val)}
            value={orgUnit}
          />
        </div>
        <div className="col-sm-6">
          <RouteDropdown
            options={Formatted_Tags || []}
            isMulti={true}
            DropdownHeading="Customer Tags"
            onChange={(val: any) => setTag(val)}
            value={tag}
          />
        </div>
        <div className="col-sm-6">
          <RouteDropdown
            placeholder="select"
            DropdownHeading="Address name"
            options={Formatted_Address || ["Doctor", "Pharmacy", "Stockiest"]}
            onChange={(val: any) => setAddress(val)}
            value={address}
          />
        </div>
        <div className="col-sm-6">
          <RouteDropdown
            DropdownHeading="Visit FQ"
            placeholder="select"
            options={Formatted_visitFeq || ["Can Edit", "Can Add"]}
            onChange={(val: any) => setVisitFeq(val)}
            value={visitFeq}
          />
        </div>
        <div className="col-sm-6">
          <CustomInput
            label="Remark"
            placeholder="Enter Remark"
            value={remark||""}
            onChange={(e: any) => setRemark(e.target.value)}
            required
            style={{
              border: "1px solid #EDEDED",
              borderRadius: "4px",
              padding: "10px",
              fontSize: "14px",
            }}
          />
        </div>
        <div className="col-sm-6">
          <PaginatedRouteDropdown
          key={orgUnit}
            DropdownHeading="Focus Brand"
            isMulti={true}
            fetchOptions={async (page: any, search: any) => {
              const res = await getBrandData({
                page,
                limit: 10,
                search: search || "",
                Orgunitid: orgUnit,
              });
              return (res?.data?.data || []).map((key: any) => ({
                id: key.BrandId,
                label: key.BrandName,
              }));
            }}
            onChange={(val: any) => setFocusBrand(val)}
            initialSelectedOptions={focusBrand}
          />
        </div>
        <div className="col-sm-6">
          <CustomInput
            label="Potential"
            placeholder="Enter Potential"
            type="number"
            value={potential}
            onChange={(e: any) => setPotential(e.target.value)}
            required
            style={{
              border: "1px solid #EDEDED",
              borderRadius: "4px",
              padding: "10px",
              fontSize: "14px",
            }}
          />
        </div>
        <div className="col-sm-6">
          <CustomInput
            label="Customer Frequency"
            type="number"
            placeholder="Enter Customer Frequency"
            value={customerFrq}
            onChange={(e: any) => setCustomerFrq(e.target.value)}
            required
            style={{
              border: "1px solid #EDEDED",
              borderRadius: "4px",
              padding: "10px",
              fontSize: "14px",
            }}
          />
        </div>
        <div className="col-sm-6">
          <CustomInput
            label="Invested Amount"
            placeholder="Enter Invested Amount"
            type="number"
            value={investedAmount}
            onChange={(e: any) => setInvestedAmount(e.target.value)}
            required
            style={{
              border: "1px solid #EDEDED",
              borderRadius: "4px",
              padding: "10px",
              fontSize: "14px",
            }}
          />
        </div>
      </div>

      {/* Buttons */}
      <div className="d-flex justify-content-start gap-2 mt-2">
        <Btn
          style={{ backgroundColor: "#43B9B2", color: "white" }}
          type="submit"
          disabled={mode == "view"}
          onClick={handleSubmit}
        >
          {mode === "add" ? "Submit" : mode === "edit" ? "Update" : "View"}
        </Btn>
        <Btn
          type="button"
          style={{ backgroundColor: "#F9FAFC", color: "#000" }}
          onClick={modalClose}
        >
          Cancel
        </Btn>
      </div>
      
    </div>
      )}
    </>
  );
};

export default OrganizationCustomerRecordModal;
